import { Button } from 'react-bootstrap';
import React from 'react';
import WarningIconDisc from './Icon/WarningIconDisc';
import { contentfulPropTypes } from '../propTypes';
import { replaceContentfulDelimiter } from '../utils/replaceContentfulDelimiter';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import withContentfulTag from '../utils/withContentfulTag';

const ReconfirmCard = ({ contentful, reconsentDue }) => {
  const navigate = useNavigate();
  const formattedDate = new Date(reconsentDue * 1000).toLocaleDateString(
    'en-GB',
    {
      day: 'numeric',
      month: 'long',
    },
  );

  return (
    <Container>
      <Header>
        <WarningIconDisc />
        <Title>{contentful?.title}</Title>
      </Header>
      <Content>
        <p>
          {replaceContentfulDelimiter(
            contentful?.body,
            '{date}',
            <DateText>{formattedDate}</DateText>,
          )}
        </p>
        <div>
          <a
            href={contentful?.link}
            target="_blank"
            className="p-0 m-0"
            rel="noreferrer">
            {contentful?.bodyEnd}
          </a>
        </div>
        <div>
          <StyledButton
            type="button"
            variant="secondary"
            className={`mt-3`}
            onClick={() => {
              navigate('/reconfirm/terms');
            }}>
            {contentful?.primaryButtonText}
          </StyledButton>
        </div>
      </Content>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  border-radius: 4px;
  border: 1px solid #ff5a35;
  background-color: #fff;
`;

const Header = styled.div`
  background-color: #ff5a35;
  display: flex;
  align-items: center;
  padding: 10px;
`;

const Title = styled.h2`
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  margin: 0 0 0 12px;
`;

const Content = styled.div`
  padding: 12px 10px;
`;

const DateText = styled.span`
  font-weight: 600;
`;

const StyledButton = styled(Button)`
  padding: 8px 80px;
`;

ReconfirmCard.propTypes = {
  ...contentfulPropTypes,
};

export default withContentfulTag(ReconfirmCard, 'web_app_reconsent_soon_alert');
